import * as React from 'react';

import _ from 'lodash';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import EnterCard from 'bundles/account-settings/components/sections/payment-method/EnterCard';
import ViewCurrentCard from 'bundles/account-settings/components/sections/payment-method/ViewCurrentCard';
import SettingsConstants from 'bundles/account-settings/constants/SettingsConstants';
import type PaymentWalletsV1 from 'bundles/naptimejs/resources/paymentWallets.v1';

import _t from 'i18n!nls/account-settings';

const { PaymentMethodSectionDisplayMode } = SettingsConstants;

const CreditCardSettingsBodyWrapper = ({ children }: { children: React.ReactNode }): React.ReactElement<'div'> => (
  <div className="rc-CreditCardSettings" id="payment-method">
    <h1 className="display-2-text top-section-title" id="a11y-navigation-heading">
      {_t('Payment')}
    </h1>
    {children}
  </div>
);

type Props = {
  wallets: Array<PaymentWalletsV1>;
  creditCardPreferences?: {
    id: number;
    paymentProcesorId: string;
  };
  showDeleteCreditCardModal: boolean;
  updateStatusDelete: {
    state: string;
  };
  isWalletUpdate: boolean;
  activeWalletId?: number;
  userId: number;
};

class CreditCardSettings extends React.Component<Props> {
  componentDidMount() {
    const { userId } = this.props;
    SettingsActionCreators.fetchCreditCardPreferences(userId);
    SettingsActionCreators.fetchPaymentWallets(userId);
  }

  getDisplayMode() {
    const { isWalletUpdate, creditCardPreferences } = this.props;

    if (isWalletUpdate || !creditCardPreferences) {
      return PaymentMethodSectionDisplayMode.ENTER_CARD;
    } else {
      return PaymentMethodSectionDisplayMode.VIEW_CURRENT_CARD;
    }
  }

  render() {
    const displayMode = this.getDisplayMode();
    const { creditCardPreferences, showDeleteCreditCardModal, updateStatusDelete, wallets, activeWalletId } =
      this.props;

    if (_.isNull(creditCardPreferences)) {
      return <CreditCardSettingsBodyWrapper>{_t('Loading...')}</CreditCardSettingsBodyWrapper>;
    } else if (displayMode === PaymentMethodSectionDisplayMode.VIEW_CURRENT_CARD) {
      return (
        <CreditCardSettingsBodyWrapper>
          <ViewCurrentCard
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ showDeleteCreditCardModal: boolean; update... Remove this comment to see the full error message
            showDeleteCreditCardModal={showDeleteCreditCardModal}
            updateStatusDelete={updateStatusDelete}
            activeWalletId={activeWalletId}
            wallets={wallets}
          />
        </CreditCardSettingsBodyWrapper>
      );
    } else if (displayMode === PaymentMethodSectionDisplayMode.ENTER_CARD) {
      return (
        <CreditCardSettingsBodyWrapper>
          <EnterCard />
        </CreditCardSettingsBodyWrapper>
      );
    } else {
      return false;
    }
  }
}

// TODO: connectToStores<Props, InputProps, Stores>
export default connectToStores<any, any>(['EnterCardFormStore'], ({ EnterCardFormStore }, props) => {
  return {
    ...props,
    isWalletUpdate: !!EnterCardFormStore.getPaymentWalletId(),
  };
})(CreditCardSettings);
